export const environment = {
	production: true,
	hmr: false,
	slackWebHook: 'https://hooks.slack.com/services/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',
};
